import { convertVariant } from '../tool';
export const settleData = (state) => {
  const {
    uuid,
    status,
    productInfo,
    tags: outerTags,
    productType,
    options,
    variants,
    dataValid,
    storeUuid,
  } = state;
  //const {values}=variants

  const { name, remarks, brand } = productInfo;
  const { tags } = outerTags;
  //const convertValues = convertValuesWhenSubmitting(values);
  return {
    uuid,
    name,
    brand,
    remarks,
    productType,
    tags,
    status,
    dataValid,
    storeUuid,
    productVariant: { options, variants: convertVariant(variants) },
  };
};
